import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function getProductsImpuestosPag (order = {}, params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    const data = await (new Promise((resolve, reject) => {
      const data = mock.getGroups
      const pages = data.data.length

      const clone = JSON.parse(JSON.stringify(data))
      if (params !== null) {
        clone.data = clone.data.slice(0, params.limit)
      }

      clone.meta.total = pages

      resolve(clone)
    }))
    data.Respuesta = (data.data.find(x => x.IdGrupo === Number.parseInt(params.idGrupo)) || { Estados: [] }).Estados
    return data
  } else {
    const req = {
      url: '/api/impuestos/getproductoimpuestospag',
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      data: order,
      params
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { getProductsImpuestosPag }
